import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["methodSelect", "valueInput", "feeContainer", "feeAmount", "disclosedFeeField"]
  static values = { feePct: Number }

  connect() {
    this.recalculate()
  }

  recalculate() {
    const select = this.methodSelectTarget
    const selectedText = select.options[select.selectedIndex]?.text || ""
    const isCard = /\((credit|debit|prepaid)\)/i.test(selectedText)

    const raw = this.valueInputTarget.value.replace(/,/g, "")
    const value = parseFloat(raw) || 0

    if (isCard && value > 0 && this.feePctValue > 0) {
      const fee = Math.round(100 * value * this.feePctValue) / 100
      this.feeAmountTarget.textContent = fee.toLocaleString("en-US", { style: "currency", currency: "USD" })
      this.feeContainerTarget.className = "text-danger small font-weight-bold"
      this.disclosedFeeFieldTarget.value = fee.toFixed(2)
    } else {
      this.feeAmountTarget.textContent = "$0.00"
      this.feeContainerTarget.className = "text-muted small"
      this.disclosedFeeFieldTarget.value = ""
    }
  }
}
